<h1 mat-dialog-title>
  <span class="title-text">
    @if (date && data.planType === 'drivers') {
      <span class="title-main">{{ data.vehicle.name }} op {{ data.dayPart.daypart.name }}</span>
      <span class="title-date">{{ moment(date).format('DD-MM-YYYY') }}</span>
    }
    @if (date && data.planType === 'planners') {
      <span class="title-main">{{ data.dayPart.daypart.name }}</span>
      <span class="title-date">{{ moment(date).format('DD-MM-YYYY') }}</span>
    }
  </span>
  <div class="buttons">
    @if (data.planType === 'drivers') {
      <button
        mat-icon-button
        aria-label="Dagdeel kopiëren voor chauffeur"
        [disabled]="loading()"
        (click)="openCopyDialog('driver')"
      >
        <mat-icon>file_copy</mat-icon>
      </button>
    }
    @if (data.planType === 'planners') {
      <button
        mat-icon-button
        aria-label="Dagdeel kopiëren voor planner"
        [disabled]="loading()"
        (click)="openCopyDialog('planner')"
      >
        <mat-icon>file_copy</mat-icon>
      </button>
    }
  </div>
</h1>
@if (!loading()) {
  <div mat-dialog-content>
    <form [formGroup]="planDayPartDayForm">
      @if (data.planType === 'drivers') {
        <mat-form-field>
          <mat-label>Welke chauffeur rijdt deze dienst?</mat-label>
          <mat-select
            cdkFocusInitial
            formControlName="driverId"
            (selectionChange)="changedUser($event.value, 'driver')"
            required
          >
            <mat-select-trigger>
              @if (getSelectedUser('driver'); as selectedDriver) {
                <ng-container
                  *ngTemplateOutlet="userInfoTemplate; context: { $implicit: selectedDriver, role: RoleEnum.Driver }"
                ></ng-container>
              } @else {
                <span>Geen</span>
              }
            </mat-select-trigger>
            <mat-option>
              <form [formGroup]="searchForm">
                <ngx-mat-select-search
                  formControlName="search"
                  placeholderLabel="Zoeken"
                  noEntriesFoundLabel="Geen resultaten gevonden"
                ></ngx-mat-select-search>
              </form>
            </mat-option>
            <mat-option [value]="'none'"> Geen </mat-option>
            @for (plannedUser of filteredUsers(); track plannedUser.id) {
              <mat-option
                [value]="plannedUser.id"
                [disabled]="
                  planDayPartDayForm.get('coDriverId')?.value === plannedUser.id ||
                  isHistoricalPrivateVehicleDriverDisabled(plannedUser.id)
                "
              >
                <ng-container
                  *ngTemplateOutlet="
                    userInfoTemplate;
                    context: {
                      $implicit: plannedUser,
                      showInfoIcon: true,
                      role: RoleEnum.Driver,
                    }
                  "
                ></ng-container>
              </mat-option>
            }
          </mat-select>
          @if (privateVehicleDriverError()) {
            <mat-error>{{ privateVehicleDriverError() }}</mat-error>
          }
        </mat-form-field>
        @if (dataStore.generalSettings.coDriverEnabled) {
          <mat-form-field>
            <mat-label>Welke bijrijder reist mee in deze dienst?</mat-label>
            <mat-select
              cdkFocusInitial
              formControlName="coDriverId"
              (selectionChange)="changedUser($event.value, 'co-driver')"
            >
              <mat-select-trigger>
                @if (getSelectedUser('co-driver'); as selectedCoDriver) {
                  <ng-container
                    *ngTemplateOutlet="
                      userInfoTemplate;
                      context: { $implicit: selectedCoDriver, role: RoleEnum.CoDriver }
                    "
                  ></ng-container>
                } @else {
                  <span>Geen</span>
                }
              </mat-select-trigger>
              <mat-option>
                <form [formGroup]="searchForm">
                  <ngx-mat-select-search
                    formControlName="searchCoDriver"
                    placeholderLabel="Zoeken"
                    noEntriesFoundLabel="Geen resultaten gevonden"
                  ></ngx-mat-select-search>
                </form>
              </mat-option>
              <mat-option [value]="'none'"> Geen </mat-option>
              @for (plannedUser of filteredCoDrivers(); track plannedUser.id) {
                <mat-option
                  [value]="plannedUser.id"
                  [disabled]="planDayPartDayForm.get('driverId')?.value === plannedUser.id"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      userInfoTemplate;
                      context: {
                        $implicit: plannedUser,
                        showInfoIcon: true,
                        role: RoleEnum.CoDriver,
                      }
                    "
                  ></ng-container>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
      @if (data.planType === 'planners') {
        <div>
          <mat-form-field>
            <mat-label>Selecteer een Planner</mat-label>
            <mat-select
              cdkFocusInitial
              formControlName="plannerIds"
              (selectionChange)="selectPlanner($event.value)"
              required
              multiple
              disableOptionCentering
            >
              <mat-select-trigger>
                {{ getSelectedPlannerNames() }}
              </mat-select-trigger>
              <mat-option>
                <form [formGroup]="searchForm">
                  <ngx-mat-select-search
                    formControlName="search"
                    placeholderLabel="Zoeken"
                    noEntriesFoundLabel="Geen resultaten gevonden"
                  ></ngx-mat-select-search>
                </form>
              </mat-option>
              <mat-option [value]="'none'"> Geen </mat-option>
              @for (plannedUser of filteredUsers(); track plannedUser.id) {
                <mat-option [value]="plannedUser.id">
                  <ng-container
                    *ngTemplateOutlet="
                      userInfoTemplate;
                      context: {
                        $implicit: plannedUser,
                        showInfoIcon: true,
                        role: RoleEnum.Planner,
                      }
                    "
                  ></ng-container>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (selectedPlannerUsers().length > 0) {
            <div class="planner-info">
              @for (planner of selectedPlannerUsers(); track planner.id) {
                <ng-container
                  *ngTemplateOutlet="
                    userInfoTemplate;
                    context: {
                      $implicit: planner,
                      showInfoIcon: true,
                      role: RoleEnum.Planner,
                      showDelete: true,
                    }
                  "
                ></ng-container>
              }
            </div>
          }
        </div>
      }
      <div>
        <div class="subtitle">Begin tijd</div>
        <div class="datetime remove-top-room">
          <mat-form-field class="hour">
            <mat-label>Uur</mat-label>
            <mat-select formControlName="startHour">
              @for (hour of hours(); track hour) {
                <mat-option [value]="hour">
                  {{ hour }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="minute">
            <mat-label>Minuut</mat-label>
            <mat-select formControlName="startMinute">
              @for (minute of minutes(); track minute.val) {
                <mat-option [value]="minute.val">
                  {{ minute.text }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div>
        <div class="subtitle">Eind tijd</div>
        <div class="datetime remove-top-room">
          <mat-form-field class="hour">
            <mat-label>Uur</mat-label>
            <mat-select formControlName="endHour">
              @for (hour of hours(); track hour) {
                <mat-option [value]="hour">
                  {{ hour }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="minute">
            <mat-label>Minuut</mat-label>
            <mat-select formControlName="endMinute">
              @for (minute of minutes(); track minute.val) {
                <mat-option [value]="minute.val">
                  {{ minute.text }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (invalidTimeCombination()) {
          <mat-error class="time-error">De begintijd moet plaatsvinden voor de eindtijd.</mat-error>
        }
      </div>
      <mat-form-field>
        <mat-label>Opmerking</mat-label>
        <textarea matInput formControlName="comment" rows="2"></textarea>
      </mat-form-field>
      @if (data.planType === 'drivers' && (driverEmail || driverPhone)) {
        <div class="driver-info">
          <div class="subtitle">Contactgegevens chauffeur:</div>
          @if (driverEmail && driverEmail.length) {
            <div class="subtitle">
              E-mail: <a target="_blank" href="mailto:{{ driverEmail }}">{{ driverEmail }}</a>
            </div>
          }
          @if (driverPhone && driverPhone.length) {
            <div class="subtitle">
              Telefoon: <a target="_blank" href="tel:{{ driverPhone }}">{{ driverPhone }}</a>
            </div>
          }
        </div>
      }
      @if (data.planType === 'drivers' && (coDriverEmail || coDriverPhone)) {
        <div class="driver-info">
          <div class="subtitle">Contactgegevens bijrijder:</div>
          @if (coDriverEmail && coDriverEmail.length) {
            <div class="subtitle">
              E-mail: <a target="_blank" href="mailto:{{ coDriverEmail }}">{{ coDriverEmail }}</a>
            </div>
          }
          @if (coDriverPhone && coDriverPhone.length) {
            <div class="subtitle">
              Telefoon: <a target="_blank" href="tel:{{ coDriverPhone }}">{{ coDriverPhone }}</a>
            </div>
          }
        </div>
      }
    </form>
  </div>
} @else {
  <div mat-dialog-content class="loading-content" aria-label="Gegevens laden">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}
<div mat-dialog-actions align="end">
  @if (isFinished) {
    <button mat-flat-button color="primary" [mat-dialog-close]="false">Sluiten</button>
  } @else {
    <button mat-button [disabled]="loading()" [mat-dialog-close]="false" (click)="restorePlannerUsers()">
      Annuleren
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="
        loading() || saving() || !planDayPartDayForm.valid || invalidTimeCombination() || !!privateVehicleDriverError()
      "
      [class.spinner]="saving()"
      (click)="data.planType === 'planners' ? savePlanner() : saveDriver()"
    >
      Opslaan
    </button>
  }
</div>

<ng-template
  #userInfoTemplate
  let-currentUser="$implicit"
  let-showInfoIcon="showInfoIcon"
  let-role="role"
  let-showDelete="showDelete"
>
  <div class="selected-user">
    <div class="info">
      @if (showInfoIcon) {
        <mat-icon
          class="info-icon"
          role="button"
          tabindex="0"
          aria-label="Gebruiker detailpagina"
          (click)="navigateToUser(currentUser.id, role)"
          (keydown.enter)="navigateToUser(currentUser.id, role)"
          (keydown.space)="$event.preventDefault(); navigateToUser(currentUser.id, role)"
        >
          info
        </mat-icon>
      }
      <div>{{ currentUser.user.name }}</div>
    </div>
    <div class="icons">
      @if (role === RoleEnum.Driver || role === RoleEnum.CoDriver) {
        <mat-icon
          [matTooltipPosition]="'above'"
          [matTooltip]="
            currentUser.ridesVehicle ? getUserInfoTooltip(role, 'vehicle') : getUserInfoTooltip(role, 'noVehicle')
          "
          [ngClass]="{
            green: currentUser.ridesVehicle,
            red: !currentUser.ridesVehicle,
          }"
        >
          taxi_alert
        </mat-icon>
      }
      <mat-icon
        [ngClass]="{
          green: currentUser.available && !currentUser.hasException && !currentUser.alreadyBooked,
          red: !currentUser.available || currentUser.hasException || currentUser.alreadyBooked,
        }"
        [matTooltip]="
          currentUser.alreadyBooked
            ? getUserInfoTooltip(role, 'alreadyBooked')
            : currentUser.available && !currentUser.hasException
              ? getUserInfoTooltip(role, 'available')
              : getUserInfoTooltip(role, 'unavailable')
        "
        [matTooltipPosition]="'above'"
      >
        event_busy
      </mat-icon>
      @if (currentUser.recommended) {
        <div class="icon-recommended"></div>
      }
      @if (!currentUser.recommended) {
        <div
          class="icon-notRecommended"
          [matTooltip]="getUserInfoTooltip(role, 'notRecommended')"
          [matTooltipPosition]="'above'"
        ></div>
      }
      @if (role === RoleEnum.Planner && showDelete) {
        <button
          mat-icon-button
          class="delete"
          aria-label="Planner uit dagdeel verwijderen"
          matTooltip="Verwijder deze planner bij dit dagdeel"
          [matTooltipPosition]="'above'"
          (click)="removePlanner(currentUser.id)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>
</ng-template>
